const languages = {
  uz: "",
  ru: "/ru",
  en: "/en",
};

const activeLanguage = localStorage.getItem("i18nextLng");

const API_URL = `https://rem.smart-lmz.uz${languages[activeLanguage]}`;
export { API_URL };
